import classnames from 'classnames';
import TextInput from 'components/forms/TextInput';
import useFilterVehicles from 'hooks/useFilterVehicles';
import { useLayoutEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setFollowSelectedVehicle, setIsFullMissionRouteVisible, setSelectedVehicle } from 'store/slices/appSlice';

import VehiclesList from './VehiclesList';

import type { VehicleV2 } from 'API';

import './styles/VehicleSearch.scss';

interface Props {
    vehicles?: VehicleV2[];
}

const VehicleSearch = ({ vehicles }: Props) => {
    const [searchInput, setSearchValue] = useState('');
    const [open, setOpen] = useState(false);
    const inputElementId = 'search-vehicle-input';
    const inputElementRef = useRef(null);

    const { fatals, errors, warnings, online, offline, total } = useFilterVehicles({
        vehicles,
        param: searchInput,
    });
    const dispatch = useDispatch();
    const handleSearchInput = (value: string) => {
        setSearchValue(value);
    };

    const clearSearchInput = () => {
        setSearchValue('');
    };

    const handleClick = (vin: string) => {
        dispatch(setSelectedVehicle({ selectedVIN: vin, pvlTriggered: true }));
        dispatch(setIsFullMissionRouteVisible(false));
        dispatch(setFollowSelectedVehicle(false));
        setOpen(false);
    };

    useLayoutEffect(() => {
        const handleList = (event: Event) => {
            const element = event.target as HTMLInputElement;
            const clickedElementId = element.getAttribute('id');
            clearSearchInput();
            if (!clickedElementId || clickedElementId !== inputElementId) {
                setOpen(false);
            }
        };

        if (inputElementRef) {
            document.addEventListener('click', handleList);
            return () => {
                document.removeEventListener('click', handleList);
            };
        }
    }, []);

    return (
        <div className='VehicleSearch'>
            <div className='VehicleSearch__inputWrapper'>
                <TextInput
                    ref={inputElementRef}
                    id={inputElementId}
                    inputClassName='VehicleSearch__input'
                    iconClassName='VehicleSearch__addon'
                    icon='rioglyph rioglyph-search'
                    placeholder='Search vehicles by name, VIN, or license plate'
                    name='search-vehicle'
                    disabled={!vehicles?.length}
                    value={searchInput}
                    onChange={handleSearchInput}
                    onSelect={() => setOpen(true)}
                />
                <span
                    onClick={clearSearchInput}
                    className={classnames('rioglyph rioglyph-remove-sign VehicleSearch__icon', {
                        'VehicleSearch__icon--hidden': !searchInput.length,
                    })}
                />
                <VehiclesList
                    fatals={fatals}
                    errors={errors}
                    warnings={warnings}
                    online={online}
                    offline={offline}
                    total={total}
                    searchInput={searchInput}
                    onClick={handleClick}
                    open={open}
                />
            </div>
        </div>
    );
};

export default VehicleSearch;
